import {
  TemplateDTO,
  WidgetTemplateDTO,
} from '@/entities/dashboards/dashboard-widget/@x/dashboard';
import { z } from 'zod/v4';
import { DashboardVariableDTO } from './variable';

export const BaseEntityDTO = z.object({
  id: z.string(),
});
export type BaseEntity = z.infer<typeof BaseEntityDTO>;

export const CITypeBindingDTO = z.object({
  ci_type_name: z.string(),
  node_id: z.string().nullable(),
});
export type CITypeBinding = z.infer<typeof CITypeBindingDTO>;

export const DashboardDTO = BaseEntityDTO.extend({
  title: z.string().min(1),
  name: z.string().min(1),
  query_id: z.string(),
  query_name: z.string().nullish(),
  private_for_user_id: z.string().nullish(),
  config: TemplateDTO.nullish(),
  is_edit: z.boolean().nullish(),
  widgets: z.record(z.string(), WidgetTemplateDTO).nullish(),
  tags: z.array(z.string()).nullish(),
  ci_type_bindings: z.array(CITypeBindingDTO).nullish(),
  write_rule: z.boolean().nullish(),
  can_edit: z.boolean().nullish(),
  variables: z.array(DashboardVariableDTO).optional(),
});
export type Dashboard = z.infer<typeof DashboardDTO>;

export const CreateDashboardDTO = DashboardDTO.omit({ id: true });
export type CreateDashboard = z.infer<typeof CreateDashboardDTO>;

export const UpdateDashboardDTO = DashboardDTO.partial();
export type UpdateDashboard = z.infer<typeof UpdateDashboardDTO>;

export const DashboardTitlesDTO = BaseEntityDTO.extend({
  title: z.string().min(1), // @IsNotEmpty()
});
export type DashboardTitles = z.infer<typeof DashboardTitlesDTO>;

export const DashboardShortDTO = BaseEntityDTO.extend({
  title: z.string().min(1),
  name: z.string().min(1),
  node_id: z.string().nullable(),
});
export type DashboardShort = z.infer<typeof DashboardShortDTO>;